export const MENU_FEATURE_COOKING_POPULUR = '料理する人に人気の献立' as const;
export const MENU_FEATURE_NONE_COOKING_POPULUR = '料理しない人に人気の献立' as const;
export const MENU_COOKING_LATEST = '料理する人向け新着献立' as const;
export const MENU_NONE_COOKING_LATEST = '料理しない人向け新着献立' as const;
export const MENU_SAME_CATEGORY = '同じカテゴリーの献立' as const;
export const MENU_RELATION_SHOPPING = '献立に関連するアイテム' as const;
export const MENU_SEARCH_TYPE = 'あなたのタイプで献立を探す' as const;

export const IDEA_LATEST = '新着アイデア' as const;
export const IDEA_INDEX = 'アイデアライブラリ' as const;
export const IDEA_RELATION_SHOPPING = 'アイデアに関連するアイテム' as const;

export const MENU_SEARCH_TAXONOMY_COOKING = '料理する人向け献立を探す' as const;
export const MENU_SEARCH_TAXONOMY_NONE_COOKING = '料理しない人向け献立を探す' as const;
export const MENU_TAXONOMY_COOKING = '料理する人向け' as const;
export const MENU_TAXONOMY_NONE_COOKING = '料理しない人向け' as const;

export const SHOPPING_FEATURE_RECOMMEND = '必ず欲しいおすすめアイテム' as const;
export const SHOPPING_SAME_CATEGORY = '同じカテゴリーのアイテム' as const;
export const SHOPPING_COMMENT_TIMELINE = 'アイテムへのコメント' as const;
export const SHOPPING_COMMENT_POST = 'アイテムへコメントする' as const;
export const SHOPPING_COMMENT_LOGIN = 'SNSアカウントでログイン' as const;

export const GTM_CLICK_EVENT_CATEGORY = 'gtm-cat' as const;
export const GTM_CLICK_EVENT_TITLE = 'gtm-title' as const;
export const GTM_CLICK_EVENT_PRICE = 'gtm-price' as const;

export const HEAD_MENU_TAXONOMY = 'HEAD_MENU_TAXONOMY' as const;
export const HEAD_MENU_DETAIL = 'HEAD_MENU_DETAIL' as const;
export const HEAD_IDEA_DETAIL = 'HEAD_IDEA_DETAIL' as const;
export const HEAD_SHOPPING_DETAIL = 'HEAD_SHOPPING_DETAIL' as const;
